import {EFileExtensions} from 'shared/constants/file-extensions';

export const ATTORNEY_UPLOAD_EXTENSIONS = [EFileExtensions.XML].toString();
